export default class profilepageForm{
  constructor() {  
    $(function(){ 
    setTimeout(function(){
		$(".alert-info").fadeOut(2000); }, 3000);
    });
	
  }
}



  